module.exports = __webpack_public_path__ + "img/9788983923813.bc721a07.jpg";